import "core-js/modules/es.json.parse.js";
import { readExcelFromRemoteFile } from "@/utils/word.js";
export default {
  name: "agreement-policy",
  data() {
    let language = JSON.parse(localStorage.getItem("language")) || "zh-CN";
    return {
      vHtml: "",
      wordURL: `https://usercenter-1251575231.cos.ap-shanghai.myqcloud.com/policy/iWork%E9%9A%90%E7%A7%81%E6%94%BF%E7%AD%96-V1.3-${language}.docx`
    };
  },
  created() {
    readExcelFromRemoteFile(this.wordURL, value => {
      this.$nextTick(() => {
        this.vHtml = value;
      });
    });
  }
};